<template>
  <a-modal
    title="关联数据互通的机器人"
    :width="900"
    :visible="visible"
    @cancel="handleCancel"
    :bodyStyle="{}"
    :maskClosable="false"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="查询类型">
              <a-select v-model="queryParam.type" placeholder="请选择查询类型" allowClear>
                <a-select-option value="1">机器人子账户</a-select-option>
                <a-select-option value="2">微信ID</a-select-option>
                <a-select-option value="3">微信昵称</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="请先选择查询类型" />
            </a-form-item>
          </a-col>
          <template v-if="advanced"></template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
      <!-- 
        :alert="options.alert"
        :rowSelection="options.rowSelection" 
      -->
    <s-table 
      ref="table" 
      rowKey="id" 
      v-if="id"
      :columns="columns" 
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection" >
      <span slot="avatar" slot-scope="text, record">
        <a-avatar shape="square" icon="user" :src="record.wx_avatar" />
      </span>
      <span slot="nickname" slot-scope="text">
        <a v-if="!text.nickname">未设置</a>
        <span v-else>{{text.nickname}}</span>
      </span>
    </s-table>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="loading" type="primary" @click="handleSubmit">确定进行关联</a-button>
    </template>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 80,
  },
  {
    title: '头像',
    scopedSlots: { customRender: 'avatar' },
    width: 80,
  },
  {
    title: '微信昵称',
    scopedSlots: { customRender: 'nickname' },
  },
  {
    title: '微信ID',
    dataIndex: 'wx_id',
  }
]
import DeviceApi from '@/api/device'
import { STable } from '@/components'
export default {
  components: {
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      columns,
      loading: false,
      visible: false,
      currentRobotId: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return DeviceApi.getList(Object.assign(parameter, this.queryParam))
      },
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
          hideDefaultSelections:true,
          type:'radio',
          getCheckboxProps: record =>({
            props: {
              disabled: record.id == this.id
            }
          })
        }
      },
      id: null
    }
  },
  created() {},
  methods: {
    show(id) {
      this.visible = true
      this.id = id
      this.$nextTick(()=>{
        this.$refs.table.refresh()
      })
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleSubmit() {
      this.loading = true
      DeviceApi.mergeDataBase(this.id,this.selectedRowKeys[0]).then(res=>{
        if(res.code === 1){
          this.$message.success('操作成功')
          this.handleCancel()
        }else{
          this.$message.info(res.msg)
        }
      }).finally(()=>{
        this.loading=false
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
